import { render, staticRenderFns } from "./ManagerShiftEditor.vue?vue&type=template&id=07b078aa&lang=pug&"
import script from "./ManagerShiftEditor.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports